module.exports = __webpack_public_path__ + "static/media/ie.636f016d.svg";